import { ClusterHead } from "app/models/loyalty-cluster.model";
import { KoncentroBaseModel } from "../../../models/koncentro-base.model";
import { Acm } from "app/models/loyalty-acm.model";

export class JsonSchema{
    mode: string;
    title: string;
    description: string;
    type: string;
    properties: JsonSchemaProperties;

    constructor(){
      this.properties = new JsonSchemaProperties();
    }
  }

  export class JsonSchemaProperties{
    infoBase: JsonSchemaFormPropertiesForm;
    condition: JsonSchemaFormPropertiesForm;
    action: JsonSchemaFormPropertiesForm;

    constructor(){
      this.infoBase = new JsonSchemaFormPropertiesForm();
      this.condition = new JsonSchemaFormPropertiesForm();
      this.action = new JsonSchemaFormPropertiesForm();
    }
  }
  export class JsonSchemaFormPropertiesForm{
    formName: string;
    id: string;
    description: string;
    form: object;

    constructor(){
      this.form = {}
    }
  }
  export class JsonSchemaLabel{
    it: string;
    en: string;
  }

  export class JsonSchemaPropertiesFormFieldsRadioOptions{
    name: string;
    value: any;
    label: JsonSchemaLabel;
    constructor(){
      this.label = new JsonSchemaLabel();
    }
  }
    export class JsonSchemaPropertiesFormFieldsProperties{
        fieldName: string;
        id: string;
        type: string;
        description: string;
        minValue: number;
        maxValue: number;
        default: string;
        maxLength: number;
        minLength: number;
        minDate: Date;
        maxDate: Date;
        required: boolean;
        pattern: string;
        disabled: boolean;
        radioOptions: Array<JsonSchemaPropertiesFormFieldsRadioOptions>
        options: Array<any>;
        optionLabel: string;
        label: JsonSchemaLabel;
        step: number;
        name: string;
        placeholder: string;
        visible: boolean;
        filterable: boolean;
        constructor(){
        this.radioOptions = new Array<JsonSchemaPropertiesFormFieldsRadioOptions>();
        this.options = new Array<any>();
        this.label = new JsonSchemaLabel();
        }
    }
  export class JsonSchemaInfoBasePropertiesFormProperties{
    cluster: JsonSchemaPropertiesFormFieldsProperties;
    acm: JsonSchemaPropertiesFormFieldsProperties;
    acm_active_range: JsonSchemaPropertiesFormFieldsProperties;
    acm_min: JsonSchemaPropertiesFormFieldsProperties;
    acm_max: JsonSchemaPropertiesFormFieldsProperties;
    cinfo_nominativo : JsonSchemaPropertiesFormFieldsProperties;
    cinfo_blacklist : JsonSchemaPropertiesFormFieldsProperties;
    rule_challenge : JsonSchemaPropertiesFormFieldsProperties;
    rule_challenge_detail : JsonSchemaPropertiesFormFieldsProperties;
    cinfo_newsletter : JsonSchemaPropertiesFormFieldsProperties;
    cinfo_recapiti : JsonSchemaPropertiesFormFieldsProperties;
    cinfo_privacy : JsonSchemaPropertiesFormFieldsProperties;

    constructor(){
      this.cluster = new JsonSchemaPropertiesFormFieldsProperties();
      this.acm = new JsonSchemaPropertiesFormFieldsProperties();
      this.acm_active_range = new JsonSchemaPropertiesFormFieldsProperties();
      this.acm_min = new JsonSchemaPropertiesFormFieldsProperties();
      this.acm_max = new JsonSchemaPropertiesFormFieldsProperties();
      this.cinfo_nominativo = new JsonSchemaPropertiesFormFieldsProperties();
      this.cinfo_blacklist = new JsonSchemaPropertiesFormFieldsProperties();
      this.rule_challenge = new JsonSchemaPropertiesFormFieldsProperties();
      this.rule_challenge_detail = new JsonSchemaPropertiesFormFieldsProperties();
      this.cinfo_newsletter = new JsonSchemaPropertiesFormFieldsProperties();
      this.cinfo_recapiti = new JsonSchemaPropertiesFormFieldsProperties;
      this.cinfo_privacy = new JsonSchemaPropertiesFormFieldsProperties();
    }
  }

  export class JsonSchemaConditionPropertiesFormProperties{
    cluster: JsonSchemaPropertiesFormFieldsProperties;
    acm: JsonSchemaPropertiesFormFieldsProperties;
    acm_min: JsonSchemaPropertiesFormFieldsProperties;
    acm_max: JsonSchemaPropertiesFormFieldsProperties;
    acm_range: JsonSchemaPropertiesFormFieldsProperties;
    acm_value: JsonSchemaPropertiesFormFieldsProperties;
    acm_reason: JsonSchemaPropertiesFormFieldsProperties;
    touchpoint: JsonSchemaPropertiesFormFieldsProperties;
    source_system: JsonSchemaPropertiesFormFieldsProperties;
    condition_notes: JsonSchemaPropertiesFormFieldsProperties;
    condition_description: JsonSchemaPropertiesFormFieldsProperties;
    condition_code: JsonSchemaPropertiesFormFieldsProperties;
    condition_type: JsonSchemaPropertiesFormFieldsProperties;
    condition_source: JsonSchemaPropertiesFormFieldsProperties;
    acm_comparison_operator: JsonSchemaPropertiesFormFieldsProperties;
    cluster_boolean_condition: JsonSchemaPropertiesFormFieldsProperties;



    constructor(){
      this.cluster = new JsonSchemaPropertiesFormFieldsProperties();
      this.acm = new JsonSchemaPropertiesFormFieldsProperties();
      this.acm_min = new JsonSchemaPropertiesFormFieldsProperties();
      this.acm_max = new JsonSchemaPropertiesFormFieldsProperties();
      this.acm_range = new JsonSchemaPropertiesFormFieldsProperties();
      this.acm_value = new JsonSchemaPropertiesFormFieldsProperties();
      this.acm_reason = new JsonSchemaPropertiesFormFieldsProperties();
      this.touchpoint = new JsonSchemaPropertiesFormFieldsProperties();
      this.source_system = new JsonSchemaPropertiesFormFieldsProperties();
      this.condition_notes = new JsonSchemaPropertiesFormFieldsProperties();
      this.condition_description = new JsonSchemaPropertiesFormFieldsProperties();
      this.condition_code = new JsonSchemaPropertiesFormFieldsProperties();
      this.condition_type = new JsonSchemaPropertiesFormFieldsProperties();
      this.condition_source = new JsonSchemaPropertiesFormFieldsProperties();
      this.acm_comparison_operator = new JsonSchemaPropertiesFormFieldsProperties();
      this.cluster_boolean_condition = new JsonSchemaPropertiesFormFieldsProperties();
    }
  }

  export class JsonSchemaActionPropertiesFormProperties{
    cluster: JsonSchemaPropertiesFormFieldsProperties;
    acm: JsonSchemaPropertiesFormFieldsProperties;
    acm_val: JsonSchemaPropertiesFormFieldsProperties;
    acm_reason: JsonSchemaPropertiesFormFieldsProperties;
    cluster_add : JsonSchemaPropertiesFormFieldsProperties;
    cluster_delete : JsonSchemaPropertiesFormFieldsProperties;
    cluster_start : JsonSchemaPropertiesFormFieldsProperties;
    cluster_end : JsonSchemaPropertiesFormFieldsProperties;
    amazon : JsonSchemaPropertiesFormFieldsProperties;
    kafka : JsonSchemaPropertiesFormFieldsProperties;
    magnews : JsonSchemaPropertiesFormFieldsProperties;
    push : JsonSchemaPropertiesFormFieldsProperties;
    kncRest : JsonSchemaPropertiesFormFieldsProperties;


    constructor(){
      this.cluster = new JsonSchemaPropertiesFormFieldsProperties();
      this.acm = new JsonSchemaPropertiesFormFieldsProperties();
      this.acm_val = new JsonSchemaPropertiesFormFieldsProperties();
      this.acm_reason = new JsonSchemaPropertiesFormFieldsProperties();
      this.cluster = new JsonSchemaPropertiesFormFieldsProperties();
      this.cluster_add = new JsonSchemaPropertiesFormFieldsProperties();
      this.cluster_delete = new JsonSchemaPropertiesFormFieldsProperties();
      this.cluster_start = new JsonSchemaPropertiesFormFieldsProperties;
      this.cluster_end = new JsonSchemaPropertiesFormFieldsProperties();
      this.amazon = new JsonSchemaPropertiesFormFieldsProperties();
      this.kafka = new JsonSchemaPropertiesFormFieldsProperties();
      this.magnews = new JsonSchemaPropertiesFormFieldsProperties();
      this.push = new JsonSchemaPropertiesFormFieldsProperties();
      this.kncRest = new JsonSchemaPropertiesFormFieldsProperties();
    }

  }

export class AuditAction extends KoncentroBaseModel{
    id: number;
    code: string;
    description: string;
    event_audit_table: string;

}

export class AuditRulesType extends KoncentroBaseModel{
    id: number;
    code: string;
    description: string;
    event_audit_table: string;

}

export class AuditEvent extends KoncentroBaseModel{
    id: number;
    eventTable?: string;
    eventType?: string;
    newRow?: string;
    oldRow?: string;
    flgDef?: string;
    retCode?: number;
    retMsg?: string;
    eventTableRowKey?: string;

}

export class AuditRule extends KoncentroBaseModel{
    id: number;
    code: string;
    auditRulesTypeId?: number;
    description?: string;
    clusterHeadId?: number;
    clusterHeadConditionId?: number;
    sourceSystemConditionId?: number;
    ochannelConditionId?: number;
    flgCluIn?: string;
    acmId?: number;
    acmConditionId?: number;
    reasonConditionId?: number;
    minAcmConditionValue?: number;
    minRangeValue?: number;
    maxRangeValue?: number;
    flgRangeActive?: string;
    flgNominativo?: string;
    flgRecapito?: string;
    flgBlacklist?: string;
    flgPrivacy?: string;
    flgNewsletter?: string;
    dtDateStart?: string;
    dtDateEnd?: string;
    eventAuditTable?: string;
    anagrafica?: boolean;
    cluster?: string;
    accumulatore?: string;
    conditionBooleanOperator?: string;
}

export class AuditRuleDtl extends KoncentroBaseModel{
    id: number;
    audit_rule_id?: number;
    id_seq?: number;
    audit_action_type_id: AuditAction;
    description?: string;
    acm_id?: number;
    reason_id?: number;
    acm_action_value?: number;
    cluster_head_id?: number;
    flg_cluster_add?: string;
    cluster_date_start?: string;
    cluster_date_end?: string;
    dt_date_start?: string;
    dt_date_end?: string;
    audit_action_external_id?: number;
    challenge_id?: number;
    challenge_description?: string;
    start_date?: string;
    end_date?: string;
    condition_entity_id?: number;
}


export class AuditRuleCondition extends KoncentroBaseModel{
  id: number;
  audit_rule_id?: number;
  id_seq?: number;
  audit_rules_condition_type_id: AuditRulesConditionType;
  code?: string;
  description?: string;
  condition_entity_id: number;
  reason_condition_id?: number;
  acm_range?: string;
  min_range_value?: number;
  max_range_value?: number;
  flg_boolean_condition?: string;
  challenge_description?: string;
  start_date?: string;
  end_date?: string;
}


export class AuditRulesApplied extends KoncentroBaseModel{
    id: number;
    audit_event_id: AuditEvent;
    audit_rule_id: AuditRule;
    audit_rule_dtl_id: AuditRuleDtl;
    msg_sent?: string;
    ret_msg?: string;
    ret_code?: number;
    card_code?: string;
    cluster_head_id?: ClusterHead;
    acm_id?: Acm;


  }

export class AuditActionExternal extends KoncentroBaseModel{

  id: number;
  code: string;
  description: string;
  endpoint?: string;
  parameters?: string;
  json_body?: JsonSchemaPropertiesFormFieldsProperties;
  audit_action_type_id: number;


}

export class AuditTemplate extends KoncentroBaseModel{
  id: number;
    code: string;
    description?: string;
    form_def: JsonSchemaPropertiesFormFieldsProperties; // Use appropriate type for JSON

}

export class AuditTemplateAssignment extends KoncentroBaseModel{
  id: number;
    template_id: number;
    assigned_to_id: number;
    assignement_entity: string;
    assignement_type?: string;

}


export class AuditRuleObject{
    rule: AuditRule = new AuditRule();
    auditRuleDtl: Array<AuditRuleDtl> = new Array<AuditRuleDtl>();
    auditRuleCondition: Array<AuditRuleCondition> = new Array<AuditRuleCondition>();
    mode: string;
}

export class AuditRulesConditionType extends KoncentroBaseModel{
  id: number;
  code: string;
  description: string;
  condition_table_ref: string;

}




// WEBPACK FOOTER //
// ./src/app/views/audit/models/audit-event.model.ts